import type { RouteMeta } from "vue-router";

// eslint-disable-next-line no-restricted-exports
export default function useAuthorisationChecker() {
    const { payload } = storeToRefs(useTokenStore());
    const config = useRuntimeConfig();

    function isAuthorised({ dev, feature, permission }: RouteMeta) {
        if (config.public.appEnv !== "local" && dev) return false;

        const needsPermission = !!permission;
        const needsFeature = !!feature;

        if (!needsPermission && !needsFeature) return true;

        if (!payload.value) return false;

        if (
            needsPermission &&
            !payload.value.permissions.includes(permission)
        ) {
            return false;
        }

        if (needsFeature && !payload.value.features[feature]) {
            return false;
        }

        return true;
    }

    return { isAuthorised };
}
